// extracted by mini-css-extract-plugin
export default {"MainPage":"MainPage_MainPage__FabgK","skip-link":"MainPage_skip-link__OFzoB"};